import * as React from "react";
import * as S from "@styled";
import { BpmnJsCliWrapper } from "../model/BpmnJsCliWrapper";
import CustomToggle from "shared/components/CustomToggle";

export const RetryTaskEditor: React.FC<RetryTaskEditorProps> = (props: RetryTaskEditorProps) => {

    const handleRetryToggleChange = (checked: boolean, event: any, id: string) => {
        if (checked !== props.shouldRetry) {
            // If the state has changed, use CLI to update the underlying xml.
            // This will in turn trigger an element changed event and update the element
            BpmnJsCliWrapper.toggleStandardLoopCharacteristicsIcon(props.elementId);
        }
    };

    const handleRetryCountUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
        let parsedInt = parseInt(event.target.value, 10);
        if (isNaN(parsedInt)) {
            parsedInt = 1;
        }
        if (parsedInt > 10) {
            parsedInt = 10; // max 10
        }
        props.onRetryCountUpdate(parsedInt);
    };

    return (
        <>
            <S.FormGroup $inline={true}>
                <S.Label>
                    {FRENDS.Localizations.RetryOnFailure}
                </S.Label>
                <CustomToggle
                    checked={props.shouldRetry}
                    onChange={handleRetryToggleChange}
                    disabled={props.disabled}
                />
            </S.FormGroup>
            {props.shouldRetry ?
                <S.FormGroup>
                    <S.Label>
                        {FRENDS.Localizations.MaximumRetries}
                    </S.Label>
                    <S.Input
                        disabled={props.disabled}
                        type="number"
                        min={1}
                        max={10}
                        value={"" + props.retryMaxCount}
                        onChange={handleRetryCountUpdate}
                    />
                </S.FormGroup> : null}
        </>
    );
};

interface RetryTaskEditorProps {
    shouldRetry: boolean;
    retryMaxCount: number;
    elementId: string;
    onRetryCountUpdate: (newValue: number) => void;
    disabled?: boolean;
}
